import React from "react";
import classnames from "classnames";
import css from "./PureSection.module.scss";
import sectionCss from "./Section.module.scss";

export type PureSectionProps = React.PropsWithChildren<{
  className?: string;
}>;
export const PureSection: React.FC<PureSectionProps> = ({ children, className }) => (
  <section className={classnames([sectionCss.section, sectionCss.paddingBottom, css.section, className])}>
    {children}
  </section>
);

export type SectionsContainerProps = React.PropsWithChildren<{
  className?: string;
}>;
export const SectionsContainer: React.FC<SectionsContainerProps> = ({ children, className }) => (
  <div className={classnames([sectionCss.paddingLeft, sectionCss.paddingRight, sectionCss.noPadding, className])}>
    {children}
  </div>
);
